import { AppContextProvider } from "./context/context";
import styles from "./index.module.scss";
import ResultContainer from "./components/resultContainer/resultContainer";
import dynamic from "next/dynamic";

const CalculatorContainer = dynamic(
  () =>
    import("./components/calculator/calculatorContainer/calculatorContainer"),
  { ssr: false }
);

export function YksCalculator() {
  return (
    <AppContextProvider>
      <div className={styles.appContainer}>
        <div className={styles.left}>
          <h1 className={styles.title}>YKS Puan Hesaplama</h1>
          <div className={styles.subTitleContainer}>
            <p className={styles.description}>
              Denemelerde veya YKS'de yaptığın doğru ve yanlış sayılarına göre
              tahmini TYT, AYT ve YDT puanlarını Kunduz 2024 YKS puan hesaplama
              robotu ile hesaplayabilirsin. Sınav puanların ÖSYM'nin belirttiği
              2024 YKS sınav kılavuzunda belirtilen şekilde hesaplanır.
            </p>
          </div>
          <CalculatorContainer />
        </div>
        <div className={styles.right}>
          <ResultContainer />
        </div>
      </div>
    </AppContextProvider>
  );
}
